import React from 'react'
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Divider,
  Chip,
} from '@material-ui/core'
import useStyles from '../../styles/styles'
import { useDispatch, useSelector } from 'react-redux'
import dialogSlice from '../../states/dialog/slice'
import shellSlice from '../../states/shell/slice'
import State from '../../states/State'
import { installOpt } from '../../fields/customer/installationField'
import PeInstallationExtra from './PeInstallationExtra'
import PeMoreInfo from '../PeMoreInfo'

const PeInstallationDialog: React.FC<{}> = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const state = useSelector((state: State) => ({
    tmp: state.shell.tmp,
    productChoice: state.shell.productChoice,
    isAuth: state.shell.isAuth,
  }));
  const { productChoice, isAuth } = state;

  const [tmpItem, setTmpItem] = React.useState(state.tmp);

  const renderOption = (target: any, prop: any) => {
    return target.map((item: any, key: any) => {
      return <Chip key={"opt-" + key}
        clickable
        className={classes.PeInstallationDialog_text} 
        label={item.label} 
        color={tmpItem.item.installations[prop] === item.value ? "primary" : "secondary"}
        variant={tmpItem.item.installations[prop] === item.value ? "default" : "outlined"}
        onClick={() => handleClick(prop, item.value)} />
    })
  }

  const handleClick = (key: any, value: any) => {
    let tmpInstallation = {
      ...tmpItem.item.installations,
      [key]: value
    };
    // standard installation
    if (key === 'standard_install' && value === 'yes') {
      tmpInstallation = {
        ...tmpItem.item.installations,
        [key]: value,
        storey_type: "single_storey",
        external_wall: "yes",
        outdoor: "on_ground",
        circuit: "circuit_existing",
        rcd: "yes",
        vertically: "yes",
        same_wall: "yes"
      }
    }
    setTmpItem({
      ...tmpItem,
      item: {
        ...tmpItem.item,
        installations: tmpInstallation,
      }
    });
  }

  const handleClose = () => {
    dispatch(dialogSlice.actions.updateCrudDialog(''));
  }

  const handleOk = () => {
    // save item
    let tmpProdChoice = {
      ...productChoice,
      [tmpItem.num]: tmpItem.item
    };
    dispatch(shellSlice.actions.updateProductChoice(tmpProdChoice));
    // close dialog
    dispatch(dialogSlice.actions.updateCrudDialog(''));
  }

  return <>
    <Dialog
        open={true}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth="md"
      >
        <DialogTitle id="responsive-dialog-title" className={classes.PeDialog_header}>
          Edit Unit {tmpItem.num}
        </DialogTitle>
        <DialogContent className={classes.PeDialog_content}>
          {Object.keys(tmpItem.item.installations).length === 0 && <PeMoreInfo label="Please choose from the options below (scroll down for more options)" type='notice'/>}
          <Typography variant='h6' 
            align='left' 
            color='primary' 
            style={{ fontFamily: 'Oswald', fontSize: '20px' }}>
            Installation options (required):
          </Typography>
          <Divider />
          <p>What type of construction are the walls of your house?</p>
          <div>{renderOption(installOpt.brick_type, 'brick_type')}</div>
          <Divider />
          <p>Standard Installation, Single Storey, Back to Back Ground, Existing Power Within 2m?</p>
          <div>{renderOption(installOpt.yes_no, 'standard_install')}</div>
          <Divider />
          <p>What level is the INDOOR unit?</p>
          <div>{renderOption(installOpt.storey_type, 'storey_type')}</div>
          <Divider />
          <p>Is Indoor unit located on an EXTERNAL wall?</p>
          <div>{renderOption(installOpt.yes_no, 'external_wall')}</div>
          <Divider />
          <p>OUTDOOR unit location</p>
          <div>{renderOption(installOpt.outdoor, 'outdoor')}</div>
          <Divider />
          <p>Electrical - Use EXISTING circuit that is NOT Kitchen or NEW circuit?</p>
          <div>{renderOption(installOpt.circuit, 'circuit')}</div>
          <Divider />
          <p>Existing circuit RCD protected?</p>
          <div>{renderOption(installOpt.yes_no, 'rcd')}</div>
          <Divider />
          <p>INDOOR unit vertically inline with the OUTDOOR unit?</p>
          <div>{renderOption(installOpt.yes_no, 'vertically')}</div>
          <Divider />
          <p>INDOOR unit on the SAME wall as OUTDOOR unit?</p>
          <div>{renderOption(installOpt.yes_no, 'same_wall')}</div>

          {isAuth && <div>
            <Typography variant='h6' 
              align='left' 
              color='primary' 
              style={{ fontFamily: 'Oswald', fontSize: '20px', marginTop: 20 }}>
              Extras (optional):
            </Typography>
            <Divider />
            <PeInstallationExtra tmpItem={tmpItem} setTmpItem={setTmpItem} />
          </div>}
          {/* <pre>{JSON.stringify(tmpItem, undefined, 2)}</pre> */}
        </DialogContent>
        <DialogActions>
          <Button
              variant="contained"
              autoFocus
              color="secondary"
              onClick={handleClose}
            >
              Cancel
          </Button>
          <Button
              variant="contained"
              autoFocus
              color="primary"
              onClick={handleOk}
            >
              OK
          </Button>
        </DialogActions>
    </Dialog>
  </>
}

export default PeInstallationDialog;